import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'

import { acGetAllBypassCustomers, acDeleteBypassCustomer } from '../../../store/actions'
import { ERRORS } from '../../../store/constants'
import { formatCNPJ } from '../../../utils'
import { ConfirmModal } from '../../default'

/**
 * @description Renders a modal component for deleting a bypass customer.
 *
 * @author Maria Eduarda Franke
 * @param {boolean} props.open - Determines if the modal is open or not.
 * @param {function} props.onClose - The function to close the modal.
 * @param {Object} props.selectedBypassCustomer - The selected bypass customer to be deleted.
 * @returns {JSX.Element} The rendered RemoveBypassCustomerModal component.
 */
const RemoveBypassCustomerModal = ({ open, onClose, selectedBypassCustomer, setSnackbarData }) => {

    const dispatch = useDispatch()

    const document = formatCNPJ(selectedBypassCustomer?.document)

    const onConfirm = () => {
        dispatch(acDeleteBypassCustomer(selectedBypassCustomer.bypass_customer_id))
            .then(() => {
                onClose()
                setSnackbarData({ open: true, severity: 'success', message: `CNPJ ${document} removido com sucesso!` })
                dispatch(acGetAllBypassCustomers())
                    .catch(error => console.error(error))
            })
            .catch(err => {
                console.error(err)
                onClose()
                setSnackbarData({ open: true, severity: 'error', message: `Não foi possível remover o CNPJ ${document}. ${ERRORS[err.description]}` })
            })
    }

    return (
        <ConfirmModal
            open={open} onClose={onClose} onConfirm={onConfirm}
            title='Remover CNPJ'
            id={selectedBypassCustomer?.bypass_customer_id}
            description={`Você tem certeza que deseja remover o CNPJ ${document} da lista de bypass?`}
        />
    )

}

RemoveBypassCustomerModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    selectedBypassCustomer: PropTypes.object,
    setSnackbarData: PropTypes.func.isRequired
}

export default RemoveBypassCustomerModal
